import { addBusinessDays, format } from "date-fns";
import React from "react";

import { selectReminderCadence } from "@performyard/engagement";
import { Text } from "@performyard/py-components";

type ReminderEmailSentEntry = {
	sent_at: Date;
	trigger: "manual" | "automatic";
};

type RemindersDetailsBoxProps = {
	frequency: number;
	nextDate: Date;
	reminderEmailsSent?: Date | ReminderEmailSentEntry[] | null;
};

const RemindersDetailsBox = ({ frequency, nextDate, reminderEmailsSent }: RemindersDetailsBoxProps) => {
	const remindersCadence = selectReminderCadence(frequency);

	const getSentReminders = (): ReminderEmailSentEntry[] => {
		console.log("reminderEmailsSent", reminderEmailsSent);
		if (!reminderEmailsSent) return [];
		if (reminderEmailsSent instanceof Date) {
			return [{ sent_at: reminderEmailsSent, trigger: "automatic" }];
		}
		if (Array.isArray(reminderEmailsSent)) {
			return reminderEmailsSent;
		}
		return [];
	};

	const sentReminders = getSentReminders();

	return (
		<div className="w-full rounded-[4px] bg-neutral-2 p-2">
			<ul>
				<Text size="caption" weight="semi-bold">
					Scheduled Reminders:{" "}
				</Text>
				{remindersCadence.length > 0 && (
					<li>
						<Text size="caption" weight="regular" overrideElement="span">
							• {format(addBusinessDays(nextDate, remindersCadence[0]), "EEEE, MMMM d, yyyy")}
						</Text>
					</li>
				)}
				{remindersCadence.length > 1 && (
					<li>
						<Text size="caption" weight="regular" overrideElement="span">
							• {format(addBusinessDays(nextDate, remindersCadence[1]), "EEEE, MMMM d, yyyy")}
						</Text>
					</li>
				)}
				{remindersCadence.length > 2 && (
					<li>
						<Text size="caption" weight="regular" overrideElement="span">
							• {format(addBusinessDays(nextDate, remindersCadence[2]), "EEEE, MMMM d, yyyy")}
						</Text>
					</li>
				)}
			</ul>
			{sentReminders.length > 0 && (
				<ul className="mt-2">
					<Text size="caption" weight="semi-bold">
						Sent Reminders:{" "}
					</Text>
					{sentReminders.map((reminder, index) => (
						<li key={index}>
							<Text size="caption" weight="regular" overrideElement="span">
								• {format(reminder.sent_at, "EEEE, MMMM d, yyyy")} (
								{reminder.trigger === "manual" ? "Manual Reminder" : "Scheduled Reminder"})
							</Text>
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default RemindersDetailsBox;
